function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7 .72a7 7 0 100 14 7 7 0 000-14zm0 12.6a5.6 5.6 0 110-11.2 5.6 5.6 0 010 11.2zm.3-8.6a.7.7 0 00-.7.7v2.8H5.2a.7.7 0 100 1.4h2.1a.7.7 0 00.7-.7v-3.5a.7.7 0 00-.7-.7z"
});

function SvgOrder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15
  }, props), _ref);
}

export default SvgOrder;